


















import {Component, Vue} from 'vue-property-decorator';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import CertificateCamp from '@/views/media/certificate/components/certificate-camp.vue';
import CertificateCamp2 from '@/views/media/certificate/components/certificate-camp2.vue';
import CampFilterComponent from '@/views/media/certificate/components/filter.vue';
import {CERTIFICATE_LEVEL_MAP, CERTIFICATE_TEMPLATE} from '@/views/media/certificate/components/filter';
import {CertificateCampData} from './components/certificate-camp';


@Component({
  components: {CertificateCamp, CertificateCamp2, CampFilterComponent}
})
export default class CertificatePrintView extends Vue {


  /**学员列表*/
  private courseList = [];
  /**模板数据*/
  private sampData: undefined | Array<any> = [];
  /**遮罩*/
  private popover: boolean = false;
  /**模板组件*/
  private sampTemplate: CERTIFICATE_TEMPLATE | undefined;

  private fileName: string = 'content.pdf';

  /**证书等级选择*/
  public levelChange(level: number) {
    let list: Array<CertificateCampData> | any = this.sampData?.map(samp => {
      return Object.assign(samp, {
        level: {
          text: CERTIFICATE_LEVEL_MAP[level].title,
          label: CERTIFICATE_LEVEL_MAP[level].label
        }
      });
    });
    this.$set(this, 'sampData', list);
  }

  /**模板选择*/
  public templateChange(event: CERTIFICATE_TEMPLATE) {
    this.sampTemplate = event;
  }

  /**打印数据加载*/
  public printItemInit(event: { data: Array<any>; file: string; }) {
    this.$set(this, 'sampData', event.data);
    this.$set(this, 'fileName', `${event.file}.pdf`);
  }

  /**显示遮罩*/
  public showPopover() {
    this.popover = true;
  }

  /**隐藏遮罩*/
  public hidePopover() {
    this.popover = false;
  }


  /**开始打印*/
  async start() {
    this.$message.loading({
      content: '加载中',
      duration: 0,
    });
    this.showPopover();
    let doc = new jsPDF({
      unit: 'pt',
      format: 'a4'
    });
    let max = document.getElementById('canvas')!.querySelectorAll('.camp').length;
    let ALL_PROMISE: Array<any> = [];
    document.getElementById('canvas')!.querySelectorAll('.camp').forEach((element: any, index: number) => {
      ALL_PROMISE.push(html2canvas(element, {
        backgroundColor: 'white',
        allowTaint: true,
        height: element!.clientHeight,
        useCORS: true
      })
        .then(canvas => {
          const href: string = canvas.toDataURL();
          doc.addImage({
            imageData: href,
            x: 0,
            y: 0,
            width: 595,
            height: 842,
          });
          doc.addPage();
        }));
    });
    await Promise.all(ALL_PROMISE);
    doc.deletePage(max + 1);
    doc.save(this.fileName);
    this.hidePopover();
    this.$message.destroy();
    doc.close();
  }

}
